module.exports = __webpack_public_path__ + "img/21.c82020f.jpg";